import React from "react";

const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.33331 1.33301H5.99998C2.66665 1.33301 1.33331 2.66634 1.33331 5.99967V9.99967C1.33331 13.333 2.66665 14.6663 5.99998 14.6663H9.99998C13.3333 14.6663 14.6666 13.333 14.6666 9.99967V8.66634"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6933 2.0135L5.43998 7.26684C5.23998 7.46684 5.03998 7.86017 4.99998 8.14684L4.71331 10.1535C4.60665 10.8802 5.11998 11.3868 5.84665 11.2868L7.85331 11.0002C8.13331 10.9602 8.52665 10.7602 8.73331 10.5602L13.9866 5.30684C14.8933 4.40017 15.32 3.34684 13.9866 2.0135C12.6533 0.680168 11.6 1.10684 10.6933 2.0135Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.94 2.7666C10.3867 4.35993 11.6333 5.6066 13.2333 6.05993"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
